(function (app, ng) {

    app.directive("fullHeightPipeContainer",
        [
            function () {
                return {
                    link: function (scope, element) {
                        element.on("dragstart",
                            function () {
                                ng.forEach(document.getElementsByClassName("pipe-container"),
                                    function (pipeContainer) {
                                        ng.element(pipeContainer).addClass("dndFullHeight");
                                    });
                            });

                        element.on("dragend",
                            function () {
                                ng.forEach(document.getElementsByClassName("pipe-container"),
                                    function (pipeContainer) {
                                        ng.element(pipeContainer).removeClass("dndFullHeight");
                                    });
                            });
                    }
                }
            }
        ])
        .directive("pipeContainerPlaceholder",
        [
            function () {
                return {
                    link: function (scope, element) {
                        var placeholder = ng.element("<li class='dndPlaceholder'></li>");

                        element.on("dragover",
                            function (event) {
                                event = event.originalEvent || event;

                                if (event.dataTransfer.types[0] === "application/x-dnd-pipe") return true;

                                var child = ng.element(element[0].querySelector(".pipe-body"));
                                var rect = element[0].getBoundingClientRect();
                                var childRect = child[0].getBoundingClientRect();

                                var isFirstHalf = event.clientY >= rect.top && event.clientY <= childRect.top;
                                var isSecondHalf = event.clientY >= (childRect.bottom + 100) &&
                                    event.clientY <= rect.bottom;
                                if (isFirstHalf) {
                                    child.prepend(placeholder);
                                } else if (isSecondHalf) {
                                    child.append(placeholder);
                                }
                                return true;
                            });

                        element.on("dragleave",
                            function () {
                                placeholder.remove();
                                return true;
                            });

                        element.on("drop",
                            function () {
                                placeholder.remove();
                            });
                    }
                }
            }
        ])
        .directive("pipeNameNodrag",
        [
            function () {
                return {
                    link: function (scope, element) {
                        element.on("focus",
                            function () {
                                ng.element("pipe-container").setAttribute("draggable", "false");
                            });
                        element.on("blur",
                            function () {
                                ng.element("pipe-container").setAttribute("draggable", "true");
                            });
                    }
                }
            }
        ])
        .directive("placeholderMatchElement",
        [
            function () {
                return {
                    link: function (scope, element) {
                        var height = 0;

                        element.on("dragstart",
                            function () {
                                height = element.height();
                            });

                        element.on("drag",
                            function () {
                                var placeholder = element.parent().children(".dndPlaceholder");
                                placeholder.css("height", height);
                            });
                    }
                }
            }
        ])
        .directive("scrollOnAdd",
        [
            function () {
                return {
                    link: function (scope, element) {

                        element.on("submit",
                            function () {
                                setTimeout(function () {
                                    var parent = ng.element(ng.element(element.parent()[0]).parent()[0]).parent()[0];
                                    parent.scrollLeft = parent.scrollWidth;
                                },
                                    100);
                            });
                    }
                }
            }
        ]);

})(window.app, window.angular);